"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = require("./Button.utils");
var _classnames = _interopRequireDefault(require("../classnames"));
var _Spinner = _interopRequireDefault(require("../../Spinner"));
var _excluded = ["variant", "inverse", "size", "showArrowForward", "showChevronDown", "showExternalIcon", "leftIcon", "loading", "disabled", "fullWidth", "children", "className", "type", "href"];
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "button": "bvqY2e",
  "disabled": "EMLnEl",
  "loading": "JyS1hk",
  "link": "F6lchI",
  "fullWidth": "_8WkqRr",
  "primary": "MaCMXp",
  "inverse": "hGNt47",
  "assistive": "wVqmS5",
  "subtle": "QTM8IP",
  "destructive": "yhxfpB",
  "destructiveAssistive": "bWdjQD",
  "destructiveSubtle": "_5AfIV1",
  "small": "jbmXZV",
  "medium": "LLYiJC",
  "large": "w9GYKJ"
};
var Button = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'assistive' : _ref$variant,
    inverse = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    showArrowForward = _ref.showArrowForward,
    showChevronDown = _ref.showChevronDown,
    showExternalIcon = _ref.showExternalIcon,
    LeftIcon = _ref.leftIcon,
    loading = _ref.loading,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    children = _ref.children,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = !href ? 'button' : 'a';
  var builtClassNames = (0, _clsx["default"])(className, _classnames["default"].BUTTON_COMPONENT, styles.button, loading && styles.loading, fullWidth && styles.fullWidth, inverse && styles.inverse, disabled && styles.disabled, href && styles.link, styles[variant], styles[size]);
  return /*#__PURE__*/_react["default"].createElement(Component
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: Need to ignore this because this component is mutable between anchor and button
  , _extends({
    ref: ref,
    type: !href ? type : undefined,
    className: builtClassNames,
    disabled: disabled || loading,
    href: href
  }, props), loading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    kind: (0, _Button.getSpinnerKind)(variant, inverse),
    statusDescription: "Undetermined"
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, LeftIcon && /*#__PURE__*/_react["default"].createElement(LeftIcon, {
    size: "small"
  }), children, (showArrowForward || showChevronDown || showExternalIcon) && (0, _Button.getRightIcon)({
    showArrowForward: showArrowForward,
    showChevronDown: showChevronDown,
    showExternalIcon: showExternalIcon
  })));
});
var _default = exports["default"] = Button;